import { render, staticRenderFns } from "./HomeWantBuy.vue?vue&type=template&id=0fc68c2f&scoped=true&"
import script from "./HomeWantBuy.vue?vue&type=script&lang=js&"
export * from "./HomeWantBuy.vue?vue&type=script&lang=js&"
import style0 from "./HomeWantBuy.vue?vue&type=style&index=0&id=0fc68c2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc68c2f",
  null
  
)

export default component.exports